export default function Hint() {
    return (<div className="hint_odoo_area">
        <div className="hint_odoo_area_inner">
            NOT VISIBLE TO THE CLIENT, ONLY TO ASSIST CUSTOMER SERVICE
        </div>
    </div>)
}